import PropTypes from "prop-types"

import { translate } from '@/utils/translations'

const Content = ({ children, pleaseVisitText }) => {

  return (
    <div id='region_recommendation_notice'>
      <h2>
        {translate('header.change_region')}
      </h2>
      <p>
        {pleaseVisitText}
      </p>
      <p>
        {translate('regions.would_you_like')}
      </p>
      {children}
    </div>
  )
}

Content.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]).isRequired,
  pleaseVisitText: PropTypes.string.isRequired
}

export default Content
